/* eslint-disable @typescript-eslint/no-var-requires */
export const SearchPropertiesByDestinationForBrands = require('./lib/SearchPropertiesByDestinationForBrands.graphql');
export const phoenixShopSearchPropertiesByLocationInput = require('./lib/phoenixShopSearchPropertiesByLocationInput.graphql');

// catalog

//Card Carousel Resorts
export const phoenixResortsCarousel = require('./lib/phoenixResortsCarousel.graphql');
